"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Token = void 0;
var Token = /*#__PURE__*/function () {
  function Token(tokenArgs) {
    _classCallCheck(this, Token);
    _defineProperty(this, "token", void 0);
    _defineProperty(this, "startCursor", void 0);
    _defineProperty(this, "endCursor", void 0);
    this.token = tokenArgs.token;
    this.startCursor = tokenArgs.startCursor;
    this.endCursor = tokenArgs.endCursor;
  }
  return _createClass(Token, null, [{
    key: "isTokenRowDelimiter",
    value: function isTokenRowDelimiter(token) {
      var content = token.token;
      return content === '\r' || content === '\n' || content === '\r\n';
    }
  }, {
    key: "isTokenCarriageReturn",
    value: function isTokenCarriageReturn(token, parserOptions) {
      return token.token === parserOptions.carriageReturn;
    }
  }, {
    key: "isTokenComment",
    value: function isTokenComment(token, parserOptions) {
      return parserOptions.supportsComments && !!token && token.token === parserOptions.comment;
    }
  }, {
    key: "isTokenEscapeCharacter",
    value: function isTokenEscapeCharacter(token, parserOptions) {
      return token.token === parserOptions.escapeChar;
    }
  }, {
    key: "isTokenQuote",
    value: function isTokenQuote(token, parserOptions) {
      return token.token === parserOptions.quote;
    }
  }, {
    key: "isTokenDelimiter",
    value: function isTokenDelimiter(token, parserOptions) {
      return token.token === parserOptions.delimiter;
    }
  }]);
}();
exports.Token = Token;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3BhcnNlci9Ub2tlbi50cyJdLCJzb3VyY2VzQ29udGVudCI6W251bGxdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztJQVVhLEtBQUs7RUFnQ2QsZUFBbUIsU0FBb0I7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUNuQyxJQUFJLENBQUMsS0FBSyxHQUFHLFNBQVMsQ0FBQyxLQUFLO0lBQzVCLElBQUksQ0FBQyxXQUFXLEdBQUcsU0FBUyxDQUFDLFdBQVc7SUFDeEMsSUFBSSxDQUFDLFNBQVMsR0FBRyxTQUFTLENBQUMsU0FBUztFQUN4QztFQUFDO0lBQUE7SUFBQSxPQW5DTSxTQUFPLG1CQUFtQixDQUFDLEtBQVk7TUFDMUMsSUFBTSxPQUFPLEdBQUcsS0FBSyxDQUFDLEtBQUs7TUFDM0IsT0FBTyxPQUFPLEtBQUssSUFBSSxJQUFJLE9BQU8sS0FBSyxJQUFJLElBQUksT0FBTyxLQUFLLE1BQU07SUFDckU7RUFBQztJQUFBO0lBQUEsT0FFTSxTQUFPLHFCQUFxQixDQUFDLEtBQVksRUFBRSxhQUE0QjtNQUMxRSxPQUFPLEtBQUssQ0FBQyxLQUFLLEtBQUssYUFBYSxDQUFDLGNBQWM7SUFDdkQ7RUFBQztJQUFBO0lBQUEsT0FFTSxTQUFPLGNBQWMsQ0FBQyxLQUFZLEVBQUUsYUFBNEI7TUFDbkUsT0FBTyxhQUFhLENBQUMsZ0JBQWdCLElBQUksQ0FBQyxDQUFDLEtBQUssSUFBSSxLQUFLLENBQUMsS0FBSyxLQUFLLGFBQWEsQ0FBQyxPQUFPO0lBQzdGO0VBQUM7SUFBQTtJQUFBLE9BRU0sU0FBTyxzQkFBc0IsQ0FBQyxLQUFZLEVBQUUsYUFBNEI7TUFDM0UsT0FBTyxLQUFLLENBQUMsS0FBSyxLQUFLLGFBQWEsQ0FBQyxVQUFVO0lBQ25EO0VBQUM7SUFBQTtJQUFBLE9BRU0sU0FBTyxZQUFZLENBQUMsS0FBWSxFQUFFLGFBQTRCO01BQ2pFLE9BQU8sS0FBSyxDQUFDLEtBQUssS0FBSyxhQUFhLENBQUMsS0FBSztJQUM5QztFQUFDO0lBQUE7SUFBQSxPQUVNLFNBQU8sZ0JBQWdCLENBQUMsS0FBWSxFQUFFLGFBQTRCO01BQ3JFLE9BQU8sS0FBSyxDQUFDLEtBQUssS0FBSyxhQUFhLENBQUMsU0FBUztJQUNsRDtFQUFDO0FBQUE7QUF4QkwiLCJpZ25vcmVMaXN0IjpbXX0=